import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import { useIntl } from 'src/common/razzle-platform-translate'


const useStyles = makeStyles((theme) => ({
    bodyContainer: {
        display: 'flex',
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 0,
        paddingBottom: 12,
        flexDirection: 'column'
    },
    indicator: {
        height: 15,
        width: 15,
        borderRadius: 4,
        marginRight: 7,
        border: '1px solid #0000002e'
    },
    indicatorAvailable: {
        background: '#fff'
    },
    indicatorNotAvailable: {
        background: '#e4e7e7b5'
    },
    indicatorSelected: {
        background: theme.palette.primary.main
    },
    indicatorError: {
        background: '#fb8787a3'
    },
    indicatorsContainer: {
        flexDirection: 'inherit',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
    },
    indicatorContent: {
        display: 'flex',
        alignItems: 'center'
    },
}))



const DefaultIndicators = (props) => {
    const { formatMessage } = useIntl()
    const classes = useStyles()

    return (
        <div className={classNames(classes.bodyContainer, classes.indicatorsContainer)}>
            <div className={classes.indicatorContent}>
                <div className={classNames(classes.indicator, classes.indicatorNotAvailable)} />
                <Typography>{ formatMessage({ id: 'Non Disponible', defaultMessage: 'Non Disponible' }) }</Typography>
            </div>
            <div className={classes.indicatorContent}>
                <div className={classNames(classes.indicator, classes.indicatorAvailable)} />
                <Typography>{ formatMessage({ id: 'Disponible', defaultMessage: 'Disponible' })}</Typography>
            </div>
            <div className={classes.indicatorContent}>
                <div className={classNames(classes.indicator, classes.indicatorSelected)} />
                <Typography>{ formatMessage({ id: 'Réservé', defaultMessage: 'Réservé' }) }</Typography>
            </div>
            <div className={classes.indicatorContent}>
                <div className={classNames(classes.indicator, classes.indicatorError)} />
                <Typography>{ formatMessage({ id: 'Séléction invalide', defaultMessage: 'Séléction invalide' }) }</Typography>
            </div>
        </div>
    )
}

export default DefaultIndicators
